function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 23.501a11.5 11.5 0 1111.5-11.5 11.513 11.513 0 01-11.5 11.5zm0-22a10.5 10.5 0 1010.5 10.5A10.512 10.512 0 0012 1.501z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 17.505H13a1.502 1.502 0 01-1.5-1.5v-6.5H10a.5.5 0 010-1h1.5a1.001 1.001 0 011 1v6.5a.501.501 0 00.5.5h1.5a.5.5 0 010 1zM11.75 7a.508.508 0 01-.36-.14.525.525 0 01-.14-.36.5.5 0 01.14-.35.534.534 0 01.71 0 .5.5 0 01.14.35.708.708 0 01-.03.2.912.912 0 01-.11.16.5.5 0 01-.35.14z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.745 7.5a.75.75 0 11.75-.75.75.75 0 01-.75.75zm0-1a.25.25 0 00-.25.25c0 .275.5.275.5 0a.25.25 0 00-.25-.25z"
});

function SvgFormInfo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "formInfo.3f0f6.svg";
export { SvgFormInfo as ReactComponent };